export default __webpack_public_path__ + "static/media/lightning-cog-white.88f4606f.svg";